import { Component } from 'react'
import s from './ActivitySummary.scss'
import { Container } from 'reactstrap'
import * as ACT from '../actions'
import { withRouter } from 'hocs'
import { connect } from 'react-redux'
import moment from 'moment'
import partition from 'lodash/partition'
import { If } from 'components/ideal-core-ui'
import { Section } from './Section'
import { makeGetRequest } from 'utils/api'
import { timezoneDate } from 'utils/helpers'

@withRouter
@connect()
class ActivitySummary extends Component {
  state = {
    activities: []
  }

  componentDidMount() {
    const { id } = this.props.router.params
    ;(async () => {
      const url = `/v1/deals/${id}/activity`
      this.props.dispatch({
        type: ACT.DEAL_ACTIVITY_FETCH_REQUESTED
      })
      const activities = await makeGetRequest(url)
      this.props.dispatch({
        type: ACT.DEAL_ACTIVITY_FETCH_SUCCESS
      })
      this.setState({
        activities
      })
    })()
  }

  render() {
    const { activities } = this.state

    if (!activities.length) {
      return <p className={s.noActivity}>No activity yet</p>
    }

    const [todayLogs, earlierLogs] = partition(activities, log => {
      const date = timezoneDate(log.date, 'HH:mm')
      const today = moment(new Date())
      return moment(today).isSame(date, 'day')
    })

    return (
      <Container>
        <If condition={todayLogs.length}>
          <Section logs={todayLogs} title="Today" />
        </If>
        <If condition={earlierLogs.length}>
          <Section logs={earlierLogs} title="Earlier" />
        </If>
      </Container>
    )
  }
}

export default ActivitySummary
